
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BillingProcessDetailsDialogComponent } from '../billing-process-details-dialog/billing-process-details-dialog.component';
import { HomeService } from 'src/home/home.service';
import { BillingProcess } from 'src/models/billingProcess.interface';
import Swal from 'sweetalert2';
import { MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { PaginatorService } from 'src/home/paginator.service';
import { interval, Subscription } from 'rxjs';
import { BillingService } from '../services/billing.service';

@Component({
  selector: 'app-billing-process',
  templateUrl: './billing-process.component.html',
  styleUrls: ['./billing-process.component.css'],
  providers: [{ provide: MatPaginatorIntl, useClass: PaginatorService }],
})

export class BillingProcessComponent implements OnInit {
  billingProcesses: BillingProcess[] = [];
  isLoading = false;
  pageSizeOptions: number[] = [10, 20, 50];
  totalItems: number = 0;
  itemsPerPage = 10;
  pageIndex = 0;
  pollingSubscription: Subscription | undefined;

  constructor(private billingService: BillingService
    , public dialog: MatDialog) { }

  ngOnInit(): void {
    this.loadBillingProcesses(1);
    this.startPolling();
  }

  ngOnDestroy(): void {
    this.stopPolling();
  }

  loadBillingProcesses(page: number): void {
    this.isLoading = true;
    this.billingService.getBillingProcesses(page).subscribe(
      (data) => {
        this.totalItems = data.totalElements;
        this.billingProcesses = this.assignOrderIds(data.results, page);
        this.isLoading = false;
      },
      (error) => {
        console.error('Error loading billing processes:', error);
        this.isLoading = false;
        Swal.fire({
          title: 'Error',
          text: 'Hubo un error al cargar los procesos de facturación. Por favor, inténtalo de nuevo.',
          icon: 'error',
          confirmButtonColor: '#d33',
        });
      }
    );
  }

  startPolling(): void {
    this.pollingSubscription = interval(15000).subscribe(() => {
      if (this.hasPendingProcesses()) {
        this.loadBillingProcesses(this.pageIndex + 1);
      }
    });
  }

  stopPolling(): void {
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
    }
  }

  hasPendingProcesses(): boolean {
    return this.billingProcesses.some(process => process.status === 'pending');
  }

  handlePageEvent(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.itemsPerPage = event.pageSize;
    this.loadBillingProcesses(this.pageIndex + 1);
  }

  showBillingProcessDetails(process: any): void {
    this.dialog.open(BillingProcessDetailsDialogComponent, {
      width: '1000px',
      height: '90vh',
      maxWidth: '95vw',
      maxHeight: '95vh',
      data: { id: process.id, pageIndex: this.pageIndex + 1 },
      panelClass: 'custom-dialog-container',
    });
  }

  getDisplayValue(value: number | null | undefined): string {
    return value === null || value === undefined ? '-' : value.toString();
  }

  assignOrderIds(processes: BillingProcess[], page: number): BillingProcess[] {
    const startOrderId = this.totalItems - ((page - 1) * this.itemsPerPage);
    processes.forEach((process, index) => {
      process.OrderId = startOrderId - index;
    });
    return processes;
  }

  getProvidersNames(providers: { name: string }[]): string {
    if (!providers || providers.length === 0) {
      return '-';
    }
    return providers.map(provider => provider.name.trim()).join(', ');
  }
}



